import { CookieSerializeOptions } from 'cookie';
import { CookieValueTypes, deleteCookie, getCookie, setCookie } from 'cookies-next';
import { IncomingMessage, ServerResponse } from 'http';

export interface Cookie {
    /**
     * The name of the cookie.
     */
    name: string;

    /**
     *  The value of the cookie.
     */
    value: string;

    /**
     * The path of the cookie
     */
    options?: CookieSerializeOptions;
}

/**
 * Based on the environment and the request we know if a secure cookie can be set.
 */
export const isSecureEnvironment = (req: IncomingMessage): boolean => {
    if (!req || !req.headers || !req.headers.host) {
        throw new Error('The "host" request header is not available');
    }

    if (process.env.NODE_ENV !== 'production') {
        return false;
    }

    const host = (req.headers.host.indexOf(':') > -1 && req.headers.host.split(':')[0]) || req.headers.host;
    return ['localhost', '127.0.0.1'].indexOf(host) <= -1;
};

export class Cookies {
    req?: IncomingMessage;
    res?: ServerResponse;

    constructor({ req, res }: { req?: IncomingMessage; res?: ServerResponse } = {}) {
        this.req = req;
        this.res = res;
    }

    static getInstance({ req, res }: { req?: IncomingMessage; res?: ServerResponse } = {}): Cookies {
        return new Cookies({ req, res });
    }

    set = (cookie: Cookie) => {
        setCookie(cookie.name, cookie.value, {
            ...cookie.options,
            req: this.req,
            res: this.res,
        });
    };
    get = (key: string, options?: CookieSerializeOptions): CookieValueTypes =>
        getCookie(key, { ...options, req: this.req, res: this.res }) || undefined;
    remove = (key: string, options?: CookieSerializeOptions) => {
        deleteCookie(key, { ...options, req: this.req, res: this.res });
    };
}
